export const INPUT_TYPES = {
	NUMBER: 'number',
	CHECKBOX: 'checkbox',
	SELECT: 'select-one',
	TEXT: 'text',
};
